import React from 'react';
import { NavigationDropdownMode } from '../../Navigation.types';
import NavigationDropdown from '../NavigationDropdown/NavigationDropdown';
import S from './NavigationItem.styles';
const NavigationItem = ({ children, dropdown = NavigationDropdownMode.None, id, openNav, promo, setOpenNav, title, url, }) => {
    const hasDropdown = dropdown !== NavigationDropdownMode.None;
    return (React.createElement(S.Item, { onKeyDown: (event) => {
            if (event.key.toLowerCase() === 'escape') {
                event.preventDefault();
                event.stopPropagation();
                setOpenNav('');
                return;
            }
        } },
        React.createElement(S.Link, { onClick: (event) => {
                // If the item has no drop down then let the link behave normally.
                if (!hasDropdown) {
                    return;
                }
                event.preventDefault();
                if (id && id !== openNav) {
                    setOpenNav(id);
                }
                else {
                    setOpenNav('');
                }
            }, href: url, isActive: openNav == id }, title),
        hasDropdown && (React.createElement(NavigationDropdown, { isActive: openNav === id, areaTitle: title, areaUrl: url, items: children, mode: dropdown, promo: promo }))));
};
export default NavigationItem;
